module.exports = __webpack_public_path__ + "img/ijevin-f4cd3cf9-7fd1-41ad-4894-08d95b7e528f.png";